import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.scss'],
})
export class ConfirmModal {
  @Input() dialogRef: any;
  @Input() title = 'Are you sure?';
  @Input() message = "You won't be able to revert this.";
  @Input() confirmText = 'Yes';
  @Input() cancelText = 'Cancel';

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onSubmitClick(): void {
    this.dialogRef.close(true);
  }
}
